'use client'; // Error boundaries must be Client Components

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({ error, unstable_retry }) {
  useEffect(() => {
    // Surface the error for client-side diagnostics / error reporting.
    console.error(error);
  }, [error]);

  return (
    <div className="max-w-container mx-auto px-10 py-32 text-center">
      <span className="label gold">Something went wrong</span>
      <h1
        className="serif text-[48px] lg:text-[72px] leading-[1.05] tracking-tight mt-5"
        style={{ textWrap: 'balance' }}
      >
        A frame came back <span className="serif-it gold">blurred</span>.
      </h1>
      <p className="mt-6 text-[17px] text-muted max-w-[460px] mx-auto leading-[1.7]">
        An unexpected error interrupted this page. Your data is untouched — try
        again, or head back home.
      </p>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        <button
          onClick={() => unstable_retry()}
          className="btn-primary px-8 py-4 label inline-flex items-center gap-2 cursor-pointer border-none"
        >
          <span className="material-symbols-outlined text-[18px]">refresh</span>
          Try again
        </button>
        <Link href="/" className="btn-ghost px-8 py-4 label inline-flex items-center gap-2">
          Back home
        </Link>
      </div>
    </div>
  );
}
